// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `br + .src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__link--GEdim {
  display: inline-block;
  margin-top: 16px;
}
.src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__breakLine--TlAPT {
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__elipsis--XZkfV {
  text-overflow: ellipsis;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/common/attributes/makeAttrLabel/labelMakers/link/LinkInternal/LinkInternal.module.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;AACF;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,gBAAA;AAAF;AAEA;EACE,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAAF","sourcesContent":["br + .link {\n  display: inline-block;\n  margin-top: 16px;\n}\n\n.breakLine {\n  word-break: break-all;\n  white-space: normal;\n  overflow: hidden;\n}\n.elipsis {\n  text-overflow: ellipsis;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": `src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__link--GEdim`,
	"breakLine": `src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__breakLine--TlAPT`,
	"elipsis": `src-common-attributes-makeAttrLabel-labelMakers-link-LinkInternal-LinkInternal-module__elipsis--XZkfV`
};
export default ___CSS_LOADER_EXPORT___;
